module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.8577d4eb.jpg";